import { render, staticRenderFns } from "./upset.vue?vue&type=template&id=235621de&scoped=true&"
import script from "./upset.vue?vue&type=script&lang=js&"
export * from "./upset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235621de",
  null
  
)

export default component.exports